export {
  RegulatoryDisclaimer,
  type RegulatoryDisclaimerProps,
} from './RegulatoryDisclaimer';
export {
  COMPACT_COPY,
  FULL_DISCLAIMER_PATH,
  VERBOSE_COPY,
  type CompactCopy,
  type Lang as RegulatoryDisclaimerLang,
  type Variant as RegulatoryDisclaimerVariant,
  type VerboseCopy,
} from './copy';
